import { Download } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import { ColumnDef } from "@tanstack/react-table";
import { FC } from "react";
import { EmployerFundStatement } from "../../../models/funding/employerFundStatement";
import { formatCurrency } from "../../../utils/formatters";
import { LoadingSpinner } from "../../shared/LoadingSpinner";
import { Table } from "../../shared/Table";

const EmployerFundStatementsTable: FC<{
  statements: EmployerFundStatement[];
  totalItems: number;
  page: number;
  pageSize: number;
  updatePage: (value: number) => void;
  updatePageSize: (value: number) => void;
  isLoading: boolean;
  handleExport?: () => void;
  isExportLoading?: boolean;
}> = ({
  statements,
  totalItems,
  page,
  pageSize,
  updatePage,
  updatePageSize,
  isLoading,
  handleExport,
  isExportLoading
}) => {
  const columns: ColumnDef<EmployerFundStatement>[] = [
    {
      header: "Invoice",
      cell: ({ row }) => {
        return (
          <Box
            onClick={() => window.open(row.original.invoiceUrl, "_blank")}
            sx={{
              textDecoration: "underline",
              cursor: "pointer",
              color: "primary.main"
            }}
          >
            View
          </Box>
        );
      },
      enableColumnFilter: false
    },
    {
      header: "Period",
      enableColumnFilter: false,
      cell: ({ row }) => {
        const date = new Date();
        date.setMonth(Number(row.original.month) - 1);
        date.setFullYear(Number(row.original.year));

        const formattedDate = date.toLocaleString("en-NZ", {
          month: "long",
          year: "numeric"
        });

        return <Box>{formattedDate}</Box>;
      }
    },
    {
      cell: ({ row }) => (
        <Box>{formatCurrency(row.original.amount.amount)}</Box>
      ),
      header: "Amount",
      enableColumnFilter: false
    }
  ];

  if (isLoading) return <LoadingSpinner />;

  return (
    <>
      <Box display="flex" width="100%">
        {handleExport && (
          <LoadingButton
            variant="outlined"
            onClick={() => handleExport()}
            startIcon={<Download />}
            size="medium"
            sx={{ maxWidth: 100, mr: 2, ml: "auto" }}
            loading={isExportLoading}
          >
            Export
          </LoadingButton>
        )}
      </Box>
      <Table<EmployerFundStatement>
        data={statements}
        totalItems={totalItems}
        columns={columns}
        isServerSidePagination={true}
        paginationPage={page}
        paginationPageSize={pageSize}
        onPageChange={updatePage}
        onPageSizeChange={updatePageSize}
      />
    </>
  );
};

export { EmployerFundStatementsTable };
